import { render } from "./CardSpecHouse.vue?vue&type=template&id=0579bd2a"
import script from "./CardSpecHouse.vue?vue&type=script&lang=js"
export * from "./CardSpecHouse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__